import { BusinessProfileUpdateStrategy } from '../../../../providers/BusinessProfileProvider';

export default {
  modals: {
    update_strategy: {
      title: 'Które lokalizacje mają zostać zaktualizowane?',
      form: {
        update_strategy: {
          options: {
            [BusinessProfileUpdateStrategy.All]: 'Wszystkie moje lokalizacje',
            [BusinessProfileUpdateStrategy.Current]: 'Tylko aktualnie wybrana lokalizacja',
          },
        },
      },
      buttons: {
        confirm: 'Potwierdź',
      },
    },
  },
  toasts: {
    error: 'Coś poszło nie tak, spróbuj ponownie lub skontaktuj się z pomocą techniczną',
    success: 'Zmiany zostały pomyślnie zapisane!',
  },
};
